import { render, staticRenderFns } from "./LecturasView.vue?vue&type=template&id=135b62c0&scoped=true"
import script from "./LecturasView.vue?vue&type=script&lang=js"
export * from "./LecturasView.vue?vue&type=script&lang=js"
import style0 from "./LecturasView.vue?vue&type=style&index=0&id=135b62c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "135b62c0",
  null
  
)

export default component.exports